export default __webpack_public_path__ + "static/media/squids.d6a29f2e.png";